import React, { useState, useRef, useEffect, createContext } from 'react';
import styled, { keyframes, css, createGlobalStyle } from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import axios from 'axios';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Oval } from 'react-loader-spinner';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  color: #365899;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  padding: 5px;\n  color: #365899;\n  text-transform: capitalize;\n  font-weight: bold;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: inherit;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  overflow-y: auto;\n  padding: 0 .8em;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    border-radius: 4px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background: transparent;\n  }\n\n  &:hover::-webkit-scrollbar-thumb {\n    background: #dedede;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n      animation: ", " 1s ease-out;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  height: 17px;\n  width: 17px;\n  top: 1.1px;\n  left: 49.7%;\n  padding-top: 1.5px;\n  position: absolute;\n  font-size: 9pt;\n  border-radius: 50%;\n  font-weight: 400;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid white;\n\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 24px;\n  width: 24px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 24px;\n  width: 24px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-sizing: border-box;\n  font-size: 15pt;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #d25032;\n  text-decoration: underline;\n  font-size: 9px;\n  margin: 0 5px;\n\n  & :hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #807973;\n  font-size: 13.5px;\n  font-weight: 500;\n  padding-bottom: 6px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  padding: 8px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  border-left: solid 15px transparent;\n  border-right: solid 15px transparent;\n  border-bottom: solid 11px #fff;\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: -8px;\n  right: 22px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  border-left: solid 12px transparent;\n  border-right: solid 12px transparent;\n  border-bottom: solid 11px #fff;\n  filter: drop-shadow(0px -2.85px 2.5px #00000015);\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: -10px;\n  right: 25px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  box-shadow: 0px 0px 7px 2px #00000015;\n  border-radius: 12px;\n  border: 0px;\n  padding: 8px;\n  right: -20px;\n  width: 445px;\n  font-size: 12px;\n  margin-top: 15px;\n  position: absolute;\n  z-index: 1;\n  background-color: white;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\nwidth: 34px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var NotificationFrontContainer = styled.div(_templateObject());
var NotificationFrontInnerContainer = styled.div(_templateObject2());
var NotificationFrontMenu = styled.div(_templateObject3());
var NotificationFrontTriangle = styled.div(_templateObject4());
var NotificationFrontTriangleBotton = styled.div(_templateObject5());
var NotificationFrontHeader = styled.div(_templateObject6());
var NotificationFrontHeaderTitle = styled.div(_templateObject7());
var NotificationFrontHeaderOption = styled.div(_templateObject8());
var NotificationFrontIcon = styled.div(_templateObject9());
var NotificationFrontImage = styled.div(_templateObject10());
var NotificationFrontIconfont = styled.div(_templateObject11());
var shrinkAndFadeOut = keyframes(_templateObject12());
var NotificationFrontCount = styled.span(_templateObject13(), function (props) {
  return props.system == 'upfy' ? "#D25032" : "#f4ad4b";
}, function (props) {
  return props.animate && css(_templateObject14(), shrinkAndFadeOut);
});
var NotificationFrontItems = styled.div(_templateObject15(), function (props) {
  return props.height + "px";
});
var NotificationFrontEmptyNotifications = styled.div(_templateObject16());
var NotificationFrontFooter = styled.div(_templateObject17());
var NotificationFrontSeeAll = styled.div(_templateObject18());

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  @font-face {\n    font-family: \"segfy_mais_icons_pipe\";\n      src: url(\"data:application/x-font-woff;charset=utf-8;base64, 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\")\n        format(\"woff\");\n        font-weight: normal;\n        font-style: normal;\n    }\n\ni[class^=\"icon-\"]:before, i[class*=\" icon-\"]:before {\n    font-family: segfy_mais_icons_pipe !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-variant: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-pipe-add_thin:before {\n    content: \"\f101\";\n}\n.icon-pipe-add:before {\n    content: \"\f102\";\n}\n.icon-pipe-arrow_down:before {\n    content: \"\f103\";\n}\n.icon-pipe-arrow_left_thin:before {\n    content: \"\f104\";\n}\n.icon-pipe-arrow_left:before {\n    content: \"\f105\";\n}\n.icon-pipe-arrow_right_thin:before {\n    content: \"\f106\";\n}\n.icon-pipe-arrow_right:before {\n    content: \"\f107\";\n}\n.icon-pipe-arrow_up:before {\n    content: \"\f108\";\n}\n.icon-pipe-barchart:before {\n    content: \"\f109\";\n}\n.icon-pipe-bell-solid-on:before {\n    content: \"\f10a\";\n}\n.icon-pipe-bell-solid:before {\n    content: \"\f10b\";\n}\n.icon-pipe-bell:before {\n    content: \"\f10c\";\n}\n.icon-pipe-brazil:before {\n    content: \"\f10d\";\n}\n.icon-pipe-calc:before {\n    content: \"\f10e\";\n}\n.icon-pipe-calendar_thin:before {\n    content: \"\f10f\";\n}\n.icon-pipe-calendar:before {\n    content: \"\f110\";\n}\n.icon-pipe-camera:before {\n    content: \"\f111\";\n}\n.icon-pipe-cancel:before {\n    content: \"\f112\";\n}\n.icon-pipe-card:before {\n    content: \"\f113\";\n}\n.icon-pipe-chat:before {\n    content: \"\f114\";\n}\n.icon-pipe-config:before {\n    content: \"\f115\";\n}\n.icon-pipe-down:before {\n    content: \"\f116\";\n}\n.icon-pipe-edit:before {\n    content: \"\f117\";\n}\n.icon-pipe-export:before {\n    content: \"\f118\";\n}\n.icon-pipe-flag:before {\n    content: \"\f119\";\n}\n.icon-pipe-fy_inverse:before {\n    content: \"\f11a\";\n}\n.icon-pipe-fy:before {\n    content: \"\f11b\";\n}\n.icon-pipe-gift:before {\n    content: \"\f11c\";\n}\n.icon-pipe-gofy:before {\n    content: \"\f11d\";\n}\n.icon-pipe-hand_cancel:before {\n    content: \"\f11e\";\n}\n.icon-pipe-hand_confirm:before {\n    content: \"\f11f\";\n}\n.icon-pipe-hand:before {\n    content: \"\f120\";\n}\n.icon-pipe-help_central:before {\n    content: \"\f121\";\n}\n.icon-pipe-home:before {\n    content: \"\f122\";\n}\n.icon-pipe-info:before {\n    content: \"\f123\";\n}\n.icon-pipe-mail:before {\n    content: \"\f124\";\n}\n.icon-pipe-map_point:before {\n    content: \"\f125\";\n}\n.icon-pipe-map:before {\n    content: \"\f126\";\n}\n.icon-pipe-more:before {\n    content: \"\f127\";\n}\n.icon-pipe-new:before {\n    content: \"\f128\";\n}\n.icon-pipe-percentual:before {\n    content: \"\f129\";\n}\n.icon-pipe-person:before {\n    content: \"\f12a\";\n}\n.icon-pipe-phone:before {\n    content: \"\f12b\";\n}\n.icon-pipe-pizzachart:before {\n    content: \"\f12c\";\n}\n.icon-pipe-print:before {\n    content: \"\f12d\";\n}\n.icon-pipe-printer:before {\n    content: \"\f12e\";\n}\n.icon-pipe-profile_card:before {\n    content: \"\f12f\";\n}\n.icon-pipe-ramo_auto:before {\n    content: \"\f130\";\n}\n.icon-pipe-refresh_thin:before {\n    content: \"\f131\";\n}\n.icon-pipe-remove_thin:before {\n    content: \"\f132\";\n}\n.icon-pipe-remove:before {\n    content: \"\f133\";\n}\n.icon-pipe-search_finances:before {\n    content: \"\f134\";\n}\n.icon-pipe-search:before {\n    content: \"\f135\";\n}\n.icon-pipe-share:before {\n    content: \"\f136\";\n}\n.icon-pipe-star:before {\n    content: \"\f137\";\n}\n.icon-pipe-trash:before {\n    content: \"\f138\";\n}\n.icon-pipe-up:before {\n    content: \"\f139\";\n}\n.icon-pipe-whatsapp:before {\n    content: \"\f13a\";\n}\n.icon-pipe-work:before {\n    content: \"\f13b\";\n}\n"], ["\n  @font-face {\n    font-family: \"segfy_mais_icons_pipe\";\n      src: url(\"data:application/x-font-woff;charset=utf-8;base64, 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\")\n        format(\"woff\");\n        font-weight: normal;\n        font-style: normal;\n    }\n\ni[class^=\"icon-\"]:before, i[class*=\" icon-\"]:before {\n    font-family: segfy_mais_icons_pipe !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-variant: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-pipe-add_thin:before {\n    content: \"\\f101\";\n}\n.icon-pipe-add:before {\n    content: \"\\f102\";\n}\n.icon-pipe-arrow_down:before {\n    content: \"\\f103\";\n}\n.icon-pipe-arrow_left_thin:before {\n    content: \"\\f104\";\n}\n.icon-pipe-arrow_left:before {\n    content: \"\\f105\";\n}\n.icon-pipe-arrow_right_thin:before {\n    content: \"\\f106\";\n}\n.icon-pipe-arrow_right:before {\n    content: \"\\f107\";\n}\n.icon-pipe-arrow_up:before {\n    content: \"\\f108\";\n}\n.icon-pipe-barchart:before {\n    content: \"\\f109\";\n}\n.icon-pipe-bell-solid-on:before {\n    content: \"\\f10a\";\n}\n.icon-pipe-bell-solid:before {\n    content: \"\\f10b\";\n}\n.icon-pipe-bell:before {\n    content: \"\\f10c\";\n}\n.icon-pipe-brazil:before {\n    content: \"\\f10d\";\n}\n.icon-pipe-calc:before {\n    content: \"\\f10e\";\n}\n.icon-pipe-calendar_thin:before {\n    content: \"\\f10f\";\n}\n.icon-pipe-calendar:before {\n    content: \"\\f110\";\n}\n.icon-pipe-camera:before {\n    content: \"\\f111\";\n}\n.icon-pipe-cancel:before {\n    content: \"\\f112\";\n}\n.icon-pipe-card:before {\n    content: \"\\f113\";\n}\n.icon-pipe-chat:before {\n    content: \"\\f114\";\n}\n.icon-pipe-config:before {\n    content: \"\\f115\";\n}\n.icon-pipe-down:before {\n    content: \"\\f116\";\n}\n.icon-pipe-edit:before {\n    content: \"\\f117\";\n}\n.icon-pipe-export:before {\n    content: \"\\f118\";\n}\n.icon-pipe-flag:before {\n    content: \"\\f119\";\n}\n.icon-pipe-fy_inverse:before {\n    content: \"\\f11a\";\n}\n.icon-pipe-fy:before {\n    content: \"\\f11b\";\n}\n.icon-pipe-gift:before {\n    content: \"\\f11c\";\n}\n.icon-pipe-gofy:before {\n    content: \"\\f11d\";\n}\n.icon-pipe-hand_cancel:before {\n    content: \"\\f11e\";\n}\n.icon-pipe-hand_confirm:before {\n    content: \"\\f11f\";\n}\n.icon-pipe-hand:before {\n    content: \"\\f120\";\n}\n.icon-pipe-help_central:before {\n    content: \"\\f121\";\n}\n.icon-pipe-home:before {\n    content: \"\\f122\";\n}\n.icon-pipe-info:before {\n    content: \"\\f123\";\n}\n.icon-pipe-mail:before {\n    content: \"\\f124\";\n}\n.icon-pipe-map_point:before {\n    content: \"\\f125\";\n}\n.icon-pipe-map:before {\n    content: \"\\f126\";\n}\n.icon-pipe-more:before {\n    content: \"\\f127\";\n}\n.icon-pipe-new:before {\n    content: \"\\f128\";\n}\n.icon-pipe-percentual:before {\n    content: \"\\f129\";\n}\n.icon-pipe-person:before {\n    content: \"\\f12a\";\n}\n.icon-pipe-phone:before {\n    content: \"\\f12b\";\n}\n.icon-pipe-pizzachart:before {\n    content: \"\\f12c\";\n}\n.icon-pipe-print:before {\n    content: \"\\f12d\";\n}\n.icon-pipe-printer:before {\n    content: \"\\f12e\";\n}\n.icon-pipe-profile_card:before {\n    content: \"\\f12f\";\n}\n.icon-pipe-ramo_auto:before {\n    content: \"\\f130\";\n}\n.icon-pipe-refresh_thin:before {\n    content: \"\\f131\";\n}\n.icon-pipe-remove_thin:before {\n    content: \"\\f132\";\n}\n.icon-pipe-remove:before {\n    content: \"\\f133\";\n}\n.icon-pipe-search_finances:before {\n    content: \"\\f134\";\n}\n.icon-pipe-search:before {\n    content: \"\\f135\";\n}\n.icon-pipe-share:before {\n    content: \"\\f136\";\n}\n.icon-pipe-star:before {\n    content: \"\\f137\";\n}\n.icon-pipe-trash:before {\n    content: \"\\f138\";\n}\n.icon-pipe-up:before {\n    content: \"\\f139\";\n}\n.icon-pipe-whatsapp:before {\n    content: \"\\f13a\";\n}\n.icon-pipe-work:before {\n    content: \"\\f13b\";\n}\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var IconButtonContainer = styled.span(_templateObject$1());

var FontIcon = function FontIcon(_ref) {
  var icon = _ref.icon,
      size = _ref.size;
  return React.createElement(IconButtonContainer, null, React.createElement("i", {
    className: "icon-pipe-" + icon,
    style: {
      fontSize: size + "pt",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: "" + (size >= 18 ? '0.5' : '1')
    }
  }));
};

FontIcon.defaultProps = {
  size: 15
};

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n    &:first-child i {\n      color: #ff9129 !important;\n      animation: ", " 4s .7s ease-in-out infinite; \n    }\n    "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor:  ", ";\n  border: none;\n  outline: 0px;\n  background-color: transparent;\n  margin-top: 5px;\n\n  &:focus {\n    outline: none;\n  }\n\n  & i {\n    color: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  0% { -webkit-transform: rotateZ(0); }\n  1% { -webkit-transform: rotateZ(30deg); }\n  3% { -webkit-transform: rotateZ(-28deg); }\n  5% { -webkit-transform: rotateZ(34deg); }\n  7% { -webkit-transform: rotateZ(-32deg); }\n  9% { -webkit-transform: rotateZ(30deg); }\n  11% { -webkit-transform: rotateZ(-28deg); }\n  13% { -webkit-transform: rotateZ(26deg); }\n  15% { -webkit-transform: rotateZ(-24deg); }\n  17% { -webkit-transform: rotateZ(22deg); }\n  19% { -webkit-transform: rotateZ(-20deg); }\n  21% { -webkit-transform: rotateZ(18deg); }\n  23% { -webkit-transform: rotateZ(-16deg); }\n  25% { -webkit-transform: rotateZ(14deg); }\n  27% { -webkit-transform: rotateZ(-12deg); }\n  29% { -webkit-transform: rotateZ(10deg); }\n  31% { -webkit-transform: rotateZ(-8deg); }\n  33% { -webkit-transform: rotateZ(6deg); }\n  35% { -webkit-transform: rotateZ(-4deg); }\n  37% { -webkit-transform: rotateZ(2deg); }\n  39% { -webkit-transform: rotateZ(-1deg); }\n  41% { -webkit-transform: rotateZ(1deg); }\n\n  43% { -webkit-transform: rotateZ(0); }\n  100% { -webkit-transform: rotateZ(0); }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var swingAnimation = keyframes(_templateObject$2());
var CustomButton = styled.button(_templateObject2$1(), function (props) {
  return props.forbidden ? "not-allowed" : "pointer";
}, function (props) {
  return props.system == 'upfy' ? "#8A8A8A" : "#f4ad4b";
}, function (props) {
  return props.animate && props.system === 'upfy' && css(_templateObject3$1(), swingAnimation);
});

var CustomIconButton = function CustomIconButton(props) {
  return React.createElement(CustomButton, {
    onClick: props.onClick,
    forbidden: props.forbidden,
    system: props.system,
    animate: props.animate
  }, React.createElement(FontIcon, {
    icon: props.icon,
    size: props.animate ? 18 : props.icon_size
  }), props.children && props.children);
};

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 8px;\n  margin-right: 3px;\n  font-size: 9.1pt;\n\n  & a,\n  button.notification_btn_link {\n    font-weight: bold;\n    color: #d25032;\n\n    &::after {\n      content: url(data:image/svg+xml;base64,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);\n      margin: 0 3px 0 5px;\n    }\n  }\n\n  button.notification_btn_link {\n    background-color: transparent;\n    border: 0;\n    cursor: pointer;\n    display: inline-block;\n    padding: 0;\n    position: relative;\n    text-decoration: underline;\n    font-size: 9.1pt;\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  height: 9.5px;\n  width: 9.5px;\n  background-color: ", ";\n  border: ", ";\n  border-radius: 50%;\n  cursor: ", "; ;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-width: 19.34px;\n  min-height: 29.34px;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: 1fr 19fr 1fr;\n  align-items: center;\n  padding: 5px 8px;\n  border-radius: 8px;\n  background-color: ", ";\n  margin-bottom: 6px;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var NotificationItemContainer = styled.div(_templateObject$3(), function (props) {
  return props.was_read ? "" : "#faf7f2";
});
var NotificationItemDotContainer = styled.div(_templateObject2$2());
var NotificationItemTrashContainer = styled.div(_templateObject3$2());
var NotificationItemDot = styled.span(_templateObject4$1(), function (props) {
  return props.was_read ? "" : "#f2937e";
}, function (props) {
  return props.was_read ? "2px solid #f2937e" : "none";
}, function (props) {
  return props.was_read ? "initial" : "pointer";
});
var NotificationItemText = styled.div(_templateObject5$1());

var NotificationItem = function NotificationItem(_ref) {
  var item = _ref.item,
      itemsState = _ref.itemsState,
      handleToggleItem = _ref.handleToggleItem,
      handleDeleteItem = _ref.handleDeleteItem,
      system = _ref.system;

  var _useState = useState(false),
      isHovering = _useState[0],
      setIsHovering = _useState[1];

  return React.createElement(NotificationItemContainer, {
    key: item.id,
    was_read: item.wasRead,
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    }
  }, React.createElement(NotificationItemDotContainer, null, React.createElement(NotificationItemDot, {
    was_read: item.wasRead,
    onClick: function onClick() {
      return handleToggleItem(item);
    }
  })), React.createElement(NotificationItemText, null, React.createElement("p", null, ReactHtmlParser(item.title), " ", item.action && item.action.text && item.action.link && React.createElement("button", {
    className: "notification_btn_link",
    onClick: function onClick() {
      var _item$action, _item$action2, _item$action3;

      handleToggleItem(item);
      window.history.pushState((_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.link, ((_item$action2 = item.action) === null || _item$action2 === void 0 ? void 0 : _item$action2.link) || "", (_item$action3 = item.action) === null || _item$action3 === void 0 ? void 0 : _item$action3.link);
    }
  }, item.action.text))), React.createElement(NotificationItemTrashContainer, null, isHovering && React.createElement(CustomIconButton, {
    forbidden: itemsState === "loading_more_data",
    icon: "trash",
    icon_size: 13,
    system: system,
    onClick: function onClick() {
      return itemsState !== "loading_more_data" ? handleDeleteItem(item) : function () {};
    }
  })));
};

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #b1aba6;\n  margin-top: 1.2em;\n  margin-bottom: 0.9em ;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var NotificationListTitle = styled.p(_templateObject$4());

var NotificationList = function NotificationList(_ref) {
  var listTitle = _ref.listTitle,
      items = _ref.items,
      itemsState = _ref.itemsState,
      handleToggleItem = _ref.handleToggleItem,
      handleDeleteItem = _ref.handleDeleteItem,
      system = _ref.system;
  return items && (items === null || items === void 0 ? void 0 : items.length) > 0 ? React.createElement("div", null, React.createElement(NotificationListTitle, null, listTitle), items === null || items === void 0 ? void 0 : items.map(function (item) {
    return React.createElement(NotificationItem, {
      key: item.id,
      item: item,
      itemsState: itemsState,
      handleToggleItem: handleToggleItem,
      handleDeleteItem: handleDeleteItem,
      system: system
    });
  })) : React.createElement(React.Fragment, null);
};

var MASK = "YYYY-MM-DD";
var filterNotificationByCloserAndFarDate = function filterNotificationByCloserAndFarDate(items, closerDate, farDate) {
  var f = items.filter(function (i) {
    return moment(i.date).isSameOrBefore(closerDate, "date") && moment(i.date).isSameOrAfter(farDate, "date");
  });
  return f;
};
var filterNotificationBeforeDate = function filterNotificationBeforeDate(items, minTimeAmountToSubtract, minTimeAmountDefinition) {
  return items.filter(function (i) {
    return moment(i.date).isBefore(moment().subtract(minTimeAmountToSubtract, minTimeAmountDefinition), "date");
  });
};
var filterNotification = function filterNotification(items, timeAmountToSubtract, timeAmountDefinition) {
  if (timeAmountToSubtract && timeAmountDefinition) {
    return items.filter(function (i) {
      return moment(i.date).format(MASK) === moment().subtract(timeAmountToSubtract, timeAmountDefinition).format(MASK);
    });
  } else {
    return items.filter(function (i) {
      return moment(i.date).format(MASK) === moment().format(MASK);
    });
  }
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding: 0 7em;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #b1aba6;\n  margin-bottom: 40px;\n\n  & strong {\n    margin-top: 2em;\n  }\n  & p {\n    margin-top: 0.5em;\n  }\n\n  & i {\n    color: #f4ad4b;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var NotificationFrontEmptyNotifications$1 = styled.div(_templateObject$5());

var EmptyNotificationsScreen = function EmptyNotificationsScreen() {
  return React.createElement(NotificationFrontEmptyNotifications$1, null, React.createElement(FontIcon, {
    icon: 'bell_tilt',
    size: 40
  }), React.createElement("strong", null, "N\xE3o h\xE1 nenhuma notifica\xE7\xE3o no momento."), React.createElement("p", null, "Quando houverem agendamentos marcados voc\xEA os ver\xE1 aqui."));
};

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  border: ", ";\n  border-top: ", ";\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  animation: spin 1s linear infinite;\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var LoadingIconContainer = styled.div(_templateObject$6(), function (props) {
  return props.width / 7 + "px solid #f3f3f3";
}, function (props) {
  return props.width / 7 + "px solid #f4ad4b";
}, function (props) {
  return props.width + "px";
}, function (props) {
  return props.width + "px";
});

var LoadingIcon = function LoadingIcon(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return React.createElement(LoadingIconContainer, {
    width: width,
    height: height
  });
};

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items:center ;\n  padding: 5px 8px;\n  margin-bottom: 6px;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var LoadingIconContainer$1 = styled.div(_templateObject$7());

var LoadingMoreNotifications = function LoadingMoreNotifications() {
  return React.createElement(LoadingIconContainer$1, null, React.createElement(LoadingIcon, {
    width: 18,
    height: 18
  }));
};

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var LoadingScreenContainer = styled.div(_templateObject$8());

var LoadingScreen = function LoadingScreen() {
  return React.createElement(LoadingScreenContainer, null, React.createElement(LoadingIcon, {
    width: 53,
    height: 53
  }));
};

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  height: 20px;\n  background-image: radial-gradient(circle, #807973 2px, transparent 2px);\n  background-size: 100% 33.33%;\n  margin-left: 2px;\n  cursor: pointer;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var ThreeDotsButtonContainer = styled.div(_templateObject$9());

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  border-left: solid 10px transparent;\n  border-right: solid 10px transparent;\n  border-bottom: solid 8px #fff;\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: -6px;\n  right: 11px;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  border-left: solid 10px transparent;\n  border-right: solid 10px transparent;\n  border-bottom: solid 8px #fff;\n  filter: drop-shadow(0px -2.85px 2.5px #00000015);\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: -6px;\n  right: 11px;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  box-shadow: 0px 0px 5px 1.5px #00000015;\n  border-radius: 7px;\n  border: 0px;\n  padding: 8px 0;\n  right: 5px;\n\n  width: 190px;\n  font-size: 12px;\n  margin-top: 15px;\n  position: absolute;\n  z-index: 1;\n  background-color: white;\n  top: 35px;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 80px;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var ThreeDotsMenuInnerContainer = styled.div(_templateObject$a());
var ThreeDotsMenuContainer = styled.div(_templateObject2$3());
var NotificationFrontTriangle$1 = styled.div(_templateObject3$3());
var NotificationFrontTriangleBotton$1 = styled.div(_templateObject4$2());

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  user-select: none;\n  height: 40px;\n  cursor: pointer;\n  font-size: 10pt;\n  display: flex;\n  padding-left: 11px;\n  align-items: center;\n  color: #b1aba6;\n  &:hover {\n    background-color: #faf7f2;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var ThreeDotsMenuItemContainer = styled.div(_templateObject$b());

var ThreeDotsMenuItem = function ThreeDotsMenuItem(_ref) {
  var label = _ref.label,
      action = _ref.action;
  return React.createElement(ThreeDotsMenuItemContainer, {
    onClick: action
  }, label);
};

var ThreeDotsMenu = function ThreeDotsMenu(_ref) {
  var onToggleAllEvent = _ref.onToggleAllEvent,
      onDeleteAllEvent = _ref.onDeleteAllEvent,
      setIsOpen = _ref.setIsOpen;
  return React.createElement(ThreeDotsMenuContainer, null, React.createElement(NotificationFrontTriangle$1, null), React.createElement(NotificationFrontTriangleBotton$1, null), React.createElement(ThreeDotsMenuInnerContainer, null, React.createElement(ThreeDotsMenuItem, {
    action: function action() {
      onToggleAllEvent();
      setIsOpen(false);
    },
    label: "Marcar todas como lidas"
  }), React.createElement(ThreeDotsMenuItem, {
    action: function action() {
      onDeleteAllEvent();
      setIsOpen(false);
    },
    label: "Excluir tudo"
  })));
};

var ThreeDotsButton = function ThreeDotsButton(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      onToggleAllEvent = _ref.onToggleAllEvent,
      onDeleteAllEvent = _ref.onDeleteAllEvent;
  var ref = useRef(null);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return function () {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [setIsOpen]);
  return React.createElement("div", {
    ref: ref
  }, React.createElement(ThreeDotsButtonContainer, {
    onClick: function onClick() {
      setIsOpen(!isOpen);
    }
  }), isOpen && React.createElement(ThreeDotsMenu, {
    onToggleAllEvent: onToggleAllEvent,
    onDeleteAllEvent: onDeleteAllEvent,
    setIsOpen: setIsOpen
  }));
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding: 0 6em;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #b1aba6;\n  margin-bottom: 40px;\n\n  & strong {\n    margin-top: 2em;\n  }\n  & p {\n    margin-top: 0.5em;\n    font-size: 11pt;\n  }\n  & h3 {\n    margin: 0.55em 0;\n    font-size: 14pt;\n  }\n\n  & i {\n    color: #d25032;\n  }\n\n  & button {\n    margin-top: 1em ;\n    font-size: 11pt;\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  background: none !important;\n  border: none;\n  padding: 0 !important;\n  color: #d25032;\n  text-decoration: underline;\n  cursor: pointer;\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var ButtonLink = styled.button(_templateObject$c());
var NotificationFrontErrorNotifications = styled.div(_templateObject2$4());

var ErrorNotificationsScreen = function ErrorNotificationsScreen() {
  return React.createElement(NotificationFrontErrorNotifications, null, React.createElement(FontIcon, {
    icon: "hand_cancel",
    size: 30
  }), React.createElement("h3", null, "Ops!"), React.createElement("p", null, "Algo deu errado. Envie-nos uma mensagem ou aguarde e atualize a p\xE1gina abaixo."), React.createElement(ButtonLink, {
    onClick: function onClick() {
      return window.location.reload();
    }
  }, "Atualizar p\xE1gina"));
};

var notificationApi = '';
var setNotificationApi = function setNotificationApi(url) {
  notificationApi = url;
};
var getNotificationApi = function getNotificationApi() {
  return notificationApi;
};

var api = function api() {
  var baseUrl = getNotificationApi() || 'https://exu.segfy.com';
  return axios.create({
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json'
    },
    withCredentials: true
  });
};

var URL = '/api/Notifications';
var countUnreadNotifications = function countUnreadNotifications(system) {
  var destinations = system === 'gofy' ? "&destinations=gofy" : '&destinations=upfy,connectbroker';
  return api().get(URL + "/Count?includeRead=false" + destinations);
};
var getNotifications = function getNotifications(page, limit) {
  var pageSize = limit != null ? limit : 20;
  var path = page ? "?includeRead=true&prioritizeSegfy=true&PageSize=" + pageSize + "&PageNumber=" + page + "&destinations=upfy,connectbroker" : '?includeRead=true&prioritizeSegfy=true&destinations=upfy,connectbroker';
  return api().get("" + URL + path);
};
var setNotificationRead = function setNotificationRead(uuid) {
  return api().patch(URL + "/" + uuid + "/User/ToggleRead");
};

var LIST_HEIGHT = 450;

var NotificationsMenu = function NotificationsMenu(_ref) {
  var notificationsHighlightCount = _ref.notificationsHighlightCount,
      items = _ref.items,
      itemsState = _ref.itemsState,
      scrolledToEndEvent = _ref.scrolledToEndEvent,
      handleToggleItem = _ref.handleToggleItem,
      handleDeleteItem = _ref.handleDeleteItem,
      onOpenEvent = _ref.onOpenEvent,
      onCloseEvent = _ref.onCloseEvent,
      onToggleAllEvent = _ref.onToggleAllEvent,
      onDeleteAllEvent = _ref.onDeleteAllEvent,
      system = _ref.system;
  var ref = useRef(null);
  var scrollRef = useRef(null);

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(false),
      isThreeDotsMenuOpen = _useState2[0],
      setIsThreeDotsMenuOpen = _useState2[1];

  var _useState3 = useState(0),
      originalDataDataLength = _useState3[0],
      setOriginalDataDataLength = _useState3[1];

  var _useState4 = useState(0),
      countUnread = _useState4[0],
      setCountUnread = _useState4[1];

  var dataLength = items ? items.length : 0;
  useEffect(function () {
    var handleCountEvent = function handleCountEvent() {
      countUnreadNotifications(system).then(function (response) {
        setCountUnread(response.data.data);
      })["catch"](function (err) {
        setCountUnread(0);
        console.error("Falha ao obter total de mensagens não lidas " + err);
      });
    };

    document.addEventListener('onNotificationRead', handleCountEvent);
    document.addEventListener('onNewNotificationEvent', handleCountEvent);
    return function () {
      document.removeEventListener('onNotificationRead', handleCountEvent);
      document.removeEventListener('onNewNotificationEvent', handleCountEvent);
    };
  }, []);
  useEffect(function () {
    setCountUnread(notificationsHighlightCount);
  }, [notificationsHighlightCount]);
  useEffect(function () {
    if (isOpen && onOpenEvent) {
      onOpenEvent();
    }
  }, [isOpen]);
  useEffect(function () {
    if (!isOpen && onCloseEvent) {
      onCloseEvent();
      setIsThreeDotsMenuOpen(false);
    }
  }, [isOpen]);
  useEffect(function () {
    var handleUrlChange = function handleUrlChange() {
      setIsOpen(false);
    };

    window.addEventListener("popstate", handleUrlChange, true);
    return function () {
      document.removeEventListener("popstate", handleUrlChange, true);
    };
  }, [setIsOpen]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return function () {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [setIsOpen]);
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (scrollRef && scrollRef.current && Math.ceil(scrollRef.current.scrollTop) + scrollRef.current.clientHeight >= scrollRef.current.scrollHeight && !["all_data_loaded", "loading_more_data"].includes(itemsState)) {
        scrolledToEndEvent();
      }
    };

    if (isOpen && scrollRef && scrollRef.current && dataLength > 0) {
      scrollRef.current.addEventListener("scroll", handleScroll);
    }

    return function () {
      if (scrollRef && scrollRef.current) {
        scrollRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [dataLength, isOpen, scrolledToEndEvent]);
  useEffect(function () {
    var _scrollRef$current;

    if (isOpen && dataLength < originalDataDataLength && scrollRef && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) && (scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollHeight) <= LIST_HEIGHT + 100 && itemsState !== "all_data_loaded") {
      scrolledToEndEvent();
    }

    setOriginalDataDataLength(dataLength);
  }, [dataLength, isOpen]);
  return React.createElement(NotificationFrontContainer, {
    ref: ref,
    className: "notifications-front"
  }, React.createElement(NotificationFrontInnerContainer, null, React.createElement(CustomIconButton, {
    icon_size: 16,
    icon: system === 'gofy' ? 'bell' : countUnread > 0 ? 'bell-solid-on' : 'bell',
    system: system,
    animate: countUnread > 0,
    onClick: function onClick() {
      if (system == 'upfy') {
        window.location.href = '/notificacoes';
      } else {
        setIsOpen(function (isOpen) {
          return !isOpen;
        });
      }
    }
  }), countUnread > 0 && React.createElement(NotificationFrontCount, {
    system: system,
    animate: countUnread > 0,
    style: {
      fontSize: countUnread >= 10 ? "7.9pt" : ""
    }
  }, countUnread < 10 ? countUnread : "9+"), isOpen && React.createElement(NotificationFrontMenu, null, React.createElement(NotificationFrontTriangle, null), React.createElement(NotificationFrontTriangleBotton, null), React.createElement("div", null, React.createElement(NotificationFrontHeader, null, React.createElement(NotificationFrontHeaderTitle, null, "Notifica\xE7\xF5es"), ["all_data_loaded", "loading_more_data", "loaded"].includes(itemsState) && React.createElement(ThreeDotsButton, {
    isOpen: isThreeDotsMenuOpen,
    setIsOpen: setIsThreeDotsMenuOpen,
    onToggleAllEvent: onToggleAllEvent,
    onDeleteAllEvent: onDeleteAllEvent
  })), ["all_data_loaded", "loading_more_data", "loaded"].includes(itemsState) && dataLength > 0 && items && React.createElement(React.Fragment, null, React.createElement(NotificationFrontItems, {
    ref: scrollRef,
    height: LIST_HEIGHT
  }, React.createElement(NotificationList, {
    items: filterNotification(items),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "Hoje",
    system: system
  }), React.createElement(NotificationList, {
    items: filterNotification(items, 1, "days"),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "Ontem",
    system: system
  }), React.createElement(NotificationList, {
    items: filterNotificationByCloserAndFarDate(items, moment().subtract(2, "days"), moment().subtract(7, "days")),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "H\xE1 1 semana",
    system: system
  }), React.createElement(NotificationList, {
    items: filterNotificationByCloserAndFarDate(items, moment().subtract(8, "days"), moment().subtract(1, "month")),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "H\xE1 1 m\xEAs",
    system: system
  }), React.createElement(NotificationList, {
    items: filterNotificationByCloserAndFarDate(items, moment().subtract(1, "month").add(1, "day"), moment().subtract(3, "months")),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "H\xE1 3 meses",
    system: system
  }), React.createElement(NotificationList, {
    items: filterNotificationByCloserAndFarDate(items, moment().subtract(3, "months").add(1, "day"), moment().subtract(6, "months")),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "H\xE1 6 meses",
    system: system
  }), React.createElement(NotificationList, {
    items: filterNotificationByCloserAndFarDate(items, moment().subtract(6, "months").add(1, "day"), moment().subtract(1, "year")),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "H\xE1 1 ano",
    system: system
  }), React.createElement(NotificationList, {
    items: filterNotificationBeforeDate(items, 1, "years"),
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    itemsState: itemsState,
    listTitle: "H\xE1 +1 ano",
    system: system
  }), itemsState !== "all_data_loaded" && React.createElement(LoadingMoreNotifications, null))), itemsState === "no_results_found" && React.createElement(EmptyNotificationsScreen, null), itemsState === "error" && React.createElement(ErrorNotificationsScreen, null), ["loading", "idle"].includes(itemsState) && React.createElement(LoadingScreen, null)))));
};

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  :root {\n    --segfy-color-black: #807973;\n    --segfy-color-shadow-black: #00000015;\n    --segfy-color-darkgrey: #b1aba6;\n    --segfy-color-darkergrey: #48413C;\n    --segfy-color-grey: #dedede;\n    --segfy-color-neutral-grey: #cccccc;\n    --segfy-color-lightgrey: #f1f3f4;\n    --segfy-color-accent: #faf7f2;\n    --segfy-color-red: #d25032;\n    --segfy-color-lightred: #f2937e;\n    --segfy-color-lighterred: #f5e2de;\n    --segfy-color-orange: #f4ad4b;\n    --segfy-color-alertorange: #efbe7a;\n    --segfy-color-lime: #e2ed8d;\n    --segfy-color-green: #69c782;\n    --segfy-color-alertgreen: #9cddad;\n    --segfy-color-lightgreen: #c8f2d3;\n    --segfy-color-cyan: #8deddb;\n    --segfy-color-lightblue: #b1dff0;\n    --segfy-color-white: #ffffff;\n    --segfy-color-progressbar-grey1: rgba(0,0,0, 0.1);\n    --segfy-color-progressbar-grey2: rgba(0,0,0, 0.87);\n    --segfy-color-progressbar-grey3: #888;\n    --segfy-color-textarea-placeholder: #BAB4B0;\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var GlobalStyle = createGlobalStyle(_templateObject$d());
var PackageWrapper = styled.div(_templateObject2$5(), function (props) {
  return props.system === 'gofy' ? "\n        .notifications-front {\n          font-family: 'OpenSans-Regular', Helvetica, Sans-Serif;\n          box-sizing: border-box;\n          margin: 0;\n          padding: 0;\n          font-size: 32px;\n          color: var(--segfy-color-black);\n          scrollbar-color: var(--segfy-color-grey) transparent;\n          scrollbar-width: thin;\n\n          div, ul, textarea {\n            &::-webkit-scrollbar {\n              width: 6px;\n            }\n\n            &::-webkit-scrollbar-track {\n              border-radius: 4px;\n              background-color: transparent;\n            }\n\n            &::-webkit-scrollbar-thumb {\n              border-radius: 10px;\n              background: transparent;\n            }\n\n            &:hover::-webkit-scrollbar-thumb {\n              background: var(--segfy-color-grey);\n            }\n          }\n\n          textarea {\n            resize: none;\n\n            &::-webkit-scrollbar-button {\n              display: none;\n            }\n          }\n\n          ::selection {\n            background-color: var(--segfy-color-lightred);\n            color: var(--segfy-color-white);\n          }\n        }\n      " : "\n        *::-webkit-scrollbar {\n          width:6px;\n        }\n        *::-webkit-scrollbar-track {\n          background: #FFF;\n        }\n        *::-webkit-scrollbar-thumb {\n          background: #62626236;\n          border-radius: 20px;\n        }\n    ";
});

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 5px;\n  display: block;\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n    margin: 0 15px 0 20px;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: ", ";\n\n  border-radius: 5px;\n  border: 1px solid transparent;\n  padding: 0;\n  transition: height 0.25s ease, width 0.25s ease;\n  ::backdrop {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n\n  @media ", " {\n    height: ", ";\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  max-width: 90%;\n  margin: 0 auto;\n  padding: 20px;\n  text-align: justify;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border-bottom: 2px solid #F1F1F2;\n  color: #777;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "412px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px"
};
var device = {
  mobileS: "(min-width: " + size.mobileS + ")",
  mobileM: "(min-width: " + size.mobileM + ")",
  mobileL: "(min-width: " + size.mobileL + ")",
  tablet: "(min-width: " + size.tablet + ")",
  laptop: "(min-width: " + size.laptop + ")",
  laptopL: "(min-width: " + size.laptopL + ")",
  desktop: "(min-width: " + size.desktop + ")",
  desktopL: "(min-width: " + size.desktop + ")"
};
var TopDialogModalContainer = styled.div(_templateObject$e());
var CloseButtonContainer = styled.div(_templateObject2$6());
var ModalBody = styled.div(_templateObject3$4());
var DialogModalContainer = styled.dialog(_templateObject4$3(), function (_ref) {
  var width = _ref.width;
  return width + "%";
}, device.tablet, function (_ref2) {
  var height = _ref2.height;
  return height + "%";
});
var DialogModalInnerContainer = styled.div(_templateObject5$2());
var NotificationImage = styled.img(_templateObject6$1());
var NotificationContent = styled.div(_templateObject7$1());
var NotificationTitle = styled.h5(_templateObject8$1());
var NotificationDescription = styled.span(_templateObject9$1());

function getDiffDays(date) {
  var dataAtual = new Date();
  var dataInformada = new Date(date);
  dataAtual.setHours(0, 0, 0, 0);
  dataInformada.setHours(0, 0, 0, 0);
  return Math.floor((dataAtual.getTime() - dataInformada.getTime()) / (1000 * 60 * 60 * 24));
}

function formatFullDate(date) {
  var day = date.getDate().toString().padStart(2, "0");
  var month = (date.getMonth() + 1).toString().padStart(2, "0");
  var year = date.getFullYear();
  return day + "/" + month + "/" + year;
}

function calcularTempoDecorrido(date) {
  var diffDays = getDiffDays(date);

  if (diffDays === 0) {
    return "Hoje";
  } else if (diffDays === 1) {
    return "Há 1 dia";
  } else if (diffDays <= 6) {
    return "H\xE1 " + diffDays + " dias";
  } else if (diffDays <= 13) {
    return "Há 1 semana";
  } else if (diffDays <= 20) {
    return "Há 2 semanas";
  } else if (diffDays <= 27) {
    return "Há 3 semanas";
  } else {
    return "Há 4 semanas";
  }
}
function formatPublicationDate(date) {
  var diffDays = getDiffDays(date);

  if (diffDays === 0) {
    return "Hoje";
  } else if (diffDays === 1) {
    return "Ontem";
  } else if (diffDays === 2) {
    return 'Anteontem';
  } else {
    return "em " + formatFullDate(new Date(date));
  }
}

var DialogModalContext = createContext(undefined);

var DialogModal = function DialogModal(_ref) {
  var notification = _ref.notification,
      isOpened = _ref.isOpened,
      actions = _ref.actions,
      onCloseAction = _ref.onCloseAction,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 90 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 90 : _ref$height;
  var ref = useRef(null);
  useEffect(function () {
    var dialog = ref.current;

    if (isOpened) {
      dialog === null || dialog === void 0 ? void 0 : dialog.removeAttribute('open');
      dialog === null || dialog === void 0 ? void 0 : dialog.showModal();
      document.body.classList.add('modal-open');
    } else {
      dialog === null || dialog === void 0 ? void 0 : dialog.close();
      document.body.classList.remove('modal-open');
    }

    return function () {
      return dialog === null || dialog === void 0 ? void 0 : dialog.close();
    };
  }, [isOpened]);

  var preventAutoClose = function preventAutoClose(e) {
    return e.stopPropagation();
  };

  return React.createElement(DialogModalContainer, {
    ref: ref,
    onCancel: onCloseAction,
    onClick: onCloseAction,
    width: width,
    height: height
  }, React.createElement(DialogModalInnerContainer, {
    onClick: preventAutoClose
  }, notification && React.createElement(TopDialogModalContainer, null, React.createElement(NotificationImage, {
    src: notification.logo,
    alt: "Logo"
  }), React.createElement(NotificationContent, null, React.createElement(NotificationTitle, null, notification.title), React.createElement(NotificationDescription, null, "Publicado por ", notification.author, " ", formatPublicationDate(notification.date))), onCloseAction && React.createElement(CloseButtonContainer, {
    onClick: onCloseAction
  }, React.createElement("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    x: '0px',
    y: '0px',
    width: '20',
    height: '20',
    viewBox: '0 0 30 30',
    fill: '#CCCCCC'
  }, React.createElement("path", {
    d: 'M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z'
  })))), React.createElement(DialogModalContext.Provider, {
    value: {
      closeModal: onCloseAction,
      actions: actions
    }
  }, notification && React.createElement(ModalBody, {
    dangerouslySetInnerHTML: {
      __html: notification.content
    }
  }))));
};

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  text-align: right;\n  text-decoration: none;\n  color: rgb(51, 122, 183) !important;\n  margin-top: 10px;\n  cursor: pointer;\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n  color: #777;\n  white-space: nowrap;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 5px;\n  display: block;\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-weight: ", "\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n    margin: 0 15px 0 20px;\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px 15px 10px 10px;\n  border-bottom: 1px solid #F1F1F2;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  background-color: white;\n  border-radius: 5px;\n  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  color: #D25032;\n  margin: 1.5rem 0 1rem 2rem;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var Container = styled.div(_templateObject$f());
var Title = styled.h4(_templateObject2$7());
var NotificationList$1 = styled.ul(_templateObject3$5());
var NotificationItemPanel = styled.li(_templateObject4$4());
var NotificationImage$1 = styled.img(_templateObject5$3());
var NotificationContent$1 = styled.div(_templateObject6$2());
var NotificationTitle$1 = styled.h5(_templateObject7$2(), function (props) {
  return props.unread ? 'bold' : 'normal';
});
var NotificationDescription$1 = styled.span(_templateObject8$2());
var TimeAgo = styled.span(_templateObject9$2());
var ShowLast30DaysLink = styled.a(_templateObject10$1());

function validateURL(url) {
  var regex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
  return regex.test(url);
}

var NotificationPanel = function NotificationPanel(props) {
  var pageSize = props.pageSize;

  var _useState = useState(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  var _useState2 = useState(),
      notificationModal = _useState2[0],
      setNotificationModal = _useState2[1];

  var _useState3 = useState([]),
      notifications = _useState3[0],
      setNotifications = _useState3[1];

  var _useState4 = useState(1),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = useState(true),
      hasNextPage = _useState5[0],
      setHasNextPage = _useState5[1];

  var _useState6 = useState('90vh'),
      scrollHeight = _useState6[0],
      setScrollHeight = _useState6[1];

  var openModal = function openModal() {
    setShowModal(true);
  };

  var closeModal = function closeModal() {
    setShowModal(false);
  };

  var isNotificationLink = function isNotificationLink(customData) {
    if (!customData || !customData.link) return false;
    return validateURL(customData.link);
  };

  var countEvent = new CustomEvent('onNotificationRead');

  var handleNotificationModal = function handleNotificationModal(n) {
    if (isNotificationLink(n.customData)) {
      window.open(n.customData.link, '_blank');
    } else {
      var modalNotification = {
        title: n.title,
        logo: n.iconUrl,
        author: n.organization,
        date: n.dispatchedAt,
        content: n.text
      };
      setNotificationModal(modalNotification);
      openModal();
    }

    if (checkUnread(n)) {
      setNotificationRead(n.id).then(function () {
        var newNotifications = setObjectNotificationRead(n.id);
        setNotifications(newNotifications);
        document.dispatchEvent(countEvent);
      })["catch"](function (err) {
        console.error("Falha ao definir mensagem como lida " + err);
      });
    }
  };

  var fetchNotifications = function fetchNotifications(page) {
    getNotifications(page, pageSize).then(function (response) {
      setHasNextPage(response.data.data.hasNextPage);
      var items = response.data.data.items;

      if (items.length > 0) {
        var loadedNotifications = notifications.concat(response.data.data.items);
        setNotifications(loadedNotifications);
      }
    })["catch"](function (err) {
      console.error("Falha ao obter lista de mensagens não lidas " + err);
    });
  };

  var getMuralHeight = function getMuralHeight() {
    var _document$getElementB;

    var mural = (_document$getElementB = document.getElementById('muralRoot')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.parentElement;

    if (mural) {
      setScrollHeight(mural.clientHeight);
    }
  };

  var fetchNotificationsEvent = function fetchNotificationsEvent() {
    setNotifications([]);
    document.dispatchEvent(countEvent);
    fetchNotifications(1);
  };

  useEffect(function () {
    window.addEventListener('resize', getMuralHeight);
    getMuralHeight();
    fetchNotifications(1);
    window.addEventListener('onNewNotificationEvent', fetchNotificationsEvent);
    return function () {
      window.removeEventListener('resize', getMuralHeight);
      window.removeEventListener('onNewNotificationEvent', fetchNotificationsEvent);
    };
  }, []);

  var loadMoreNotifications = function loadMoreNotifications() {
    if (hasNextPage) {
      var newPage = page + 1;
      setPage(newPage);
      fetchNotifications(newPage);
    }
  };

  var checkUnread = function checkUnread(item) {
    return !(item.users.length > 0 && item.users[0].isRead);
  };

  var setObjectNotificationRead = function setObjectNotificationRead(id) {
    var notificationIndex = notifications.findIndex(function (item) {
      return item.id === id;
    });

    if (notificationIndex !== -1) {
      var updatedNotification = _extends({}, notifications[notificationIndex], {
        users: [_extends({}, notifications[notificationIndex].users[0], {
          isRead: true
        })].concat(notifications[notificationIndex].users.slice(1))
      });

      var newNotifications = [].concat(notifications.slice(0, notificationIndex), [updatedNotification], notifications.slice(notificationIndex + 1));
      return newNotifications;
    } else {
      return notifications;
    }
  };

  return React.createElement(Container, null, React.createElement(NotificationList$1, null, React.createElement(InfiniteScroll, {
    dataLength: notifications.length,
    next: loadMoreNotifications,
    hasMore: hasNextPage,
    height: scrollHeight,
    loader: React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        marginTop: "15px"
      }
    }, React.createElement(Oval, {
      height: 40,
      width: 40,
      color: "#f4ad4b",
      visible: true,
      ariaLabel: 'oval-loading',
      secondaryColor: "#efbe7a",
      strokeWidth: 2,
      strokeWidthSecondary: 2
    })),
    endMessage: React.createElement("p", {
      style: {
        textAlign: "center",
        marginTop: "15px"
      }
    }, "Todas as notifica\xE7\xF5es foram carregadas.")
  }, notifications && notifications.map(function (notification) {
    return React.createElement(NotificationItemPanel, {
      onClick: function onClick() {
        handleNotificationModal(notification);
      },
      key: notification.id
    }, React.createElement(NotificationImage$1, {
      src: notification.iconUrl,
      alt: "Logo"
    }), React.createElement(NotificationContent$1, null, React.createElement(NotificationTitle$1, {
      unread: checkUnread(notification)
    }, notification.title), React.createElement(NotificationDescription$1, null, notification.description)), React.createElement(TimeAgo, null, calcularTempoDecorrido(notification.dispatchedAt)));
  }))), showModal && React.createElement(DialogModal, {
    width: 70,
    height: 70,
    isOpened: showModal,
    onCloseAction: closeModal,
    notification: notificationModal
  }));
};

var SegfyNotifications = function SegfyNotifications(_ref) {
  var notificationsHighlightCount = _ref.notificationsHighlightCount,
      items = _ref.items,
      itemsState = _ref.itemsState,
      isMenu = _ref.isMenu,
      system = _ref.system,
      pageSize = _ref.pageSize,
      notificationApi = _ref.notificationApi,
      scrolledToEndEvent = _ref.scrolledToEndEvent,
      handleToggleItem = _ref.handleToggleItem,
      handleDeleteItem = _ref.handleDeleteItem,
      onOpenEvent = _ref.onOpenEvent,
      onCloseEvent = _ref.onCloseEvent,
      onToggleAllEvent = _ref.onToggleAllEvent,
      onDeleteAllEvent = _ref.onDeleteAllEvent;

  if (notificationApi) {
    setNotificationApi(notificationApi);
  }

  var _useState = useState(notificationsHighlightCount),
      unreadNotificationsCount = _useState[0],
      setUnreadNotificationsCount = _useState[1];

  var getUnreadNotification = function getUnreadNotification() {
    if (system === 'gofy' || system === 'upfy' && getNotificationApi().length > 0) {
      countUnreadNotifications(system).then(function (response) {
        setUnreadNotificationsCount(response.data.data);
      })["catch"](function (err) {
        setUnreadNotificationsCount(0);
        console.error("Falha ao obter total de mensagens não lidas " + err);
      });
    }
  };

  useEffect(function () {
    getUnreadNotification();
  }, []);
  useEffect(function () {
    getUnreadNotification();
  }, [notificationsHighlightCount]);
  return React.createElement(React.Fragment, null, React.createElement(GlobalStyle, null), React.createElement(PackageWrapper, {
    system: system
  }, !isMenu ? React.createElement("div", {
    className: "notifications-front"
  }, React.createElement(NotificationPanel, {
    pageSize: pageSize
  })) : React.createElement(NotificationsMenu, {
    notificationsHighlightCount: unreadNotificationsCount,
    items: items != null ? items : [],
    itemsState: itemsState,
    scrolledToEndEvent: scrolledToEndEvent,
    handleToggleItem: handleToggleItem,
    handleDeleteItem: handleDeleteItem,
    onOpenEvent: onOpenEvent,
    onCloseEvent: onCloseEvent,
    onToggleAllEvent: onToggleAllEvent,
    onDeleteAllEvent: onDeleteAllEvent,
    system: system
  })));
};

export default SegfyNotifications;
//# sourceMappingURL=index.modern.js.map
